module.exports = new __parcel__URL__("shreekanth.33eefae3.png").toString();